import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Chip } from '@scramble/ui';
import { LOAN_GROUPS, LOAN_GROUPS_IDS } from '@/helpers/constants';
import { useAllocationStatus } from '@/pages/InvestingPage/hooks/useAllocationStatus';
import { TableView } from './table';
import s from './index.module.scss';

export const EarningSchedule = ({ data }) => {
  const { t } = useTranslation();
  const [tab, setTab] = useState(LOAN_GROUPS_IDS.conservative.id);

  const { allocatedGroupA, allocatedGroupB } = useAllocationStatus();

  useEffect(() => {
    if (allocatedGroupA) {
      setTab(LOAN_GROUPS_IDS.conservative.id);
    } else if (allocatedGroupB) {
      setTab(LOAN_GROUPS_IDS.moderate.id);
    }
  }, [allocatedGroupA, allocatedGroupB]);

  if (!data || !tab) {
    return null;
  }

  const LOAN_GROUPS_T = LOAN_GROUPS(t);

  return (
    <div className={s.schedule}>
      {allocatedGroupA && allocatedGroupB ? (
        <div className={s.chips}>
          <Chip
            size="medium"
            selected={tab === LOAN_GROUPS_IDS.conservative.id}
            onClick={() => setTab(LOAN_GROUPS_IDS.conservative.id)}
          >
            {LOAN_GROUPS_T.conservative.full_name}
          </Chip>
          <Chip
            size="medium"
            selected={tab === LOAN_GROUPS_IDS.moderate.id}
            onClick={() => setTab(LOAN_GROUPS_IDS.moderate.id)}
          >
            {LOAN_GROUPS_T.moderate.full_name}
          </Chip>
        </div>
      ) : (
        <div className="f-body-sm">
          {!!allocatedGroupA && t('investing:earnings_schedule.conservative')}
          {!!allocatedGroupB && t('investing:earnings_schedule.moderate')}
        </div>
      )}
      <TableView
        tab={tab}
        data={data}
        allocatedAmount={
          tab === LOAN_GROUPS_IDS.conservative.id
            ? allocatedGroupA
            : tab === LOAN_GROUPS_IDS.moderate.id
              ? allocatedGroupB
              : 0
        }
      />
    </div>
  );
};
